// extracted by mini-css-extract-plugin
export default {"wrapper":"rlwgDz0BPLfN0CoyVAxJ","link":"a5p6WZrLr5ztliG6g7rz"};